import FlexContainer from '@components/utils/FlexContainer';
import {
  BasketVariationViewModel,
  BasketVariationPromotionViewModel,
} from '@api/v3';
import RadioGroup from '@components/RadioGroup';

import { SelectablePromotion } from './types';
import { OptionLabel, OptionWrapper, Title } from './styled';

const getLabel = (option: BasketVariationPromotionViewModel) => {
  return <OptionLabel>{option.name}</OptionLabel>;
};
const getValue = (
  option: BasketVariationViewModel['promotions'][number],
  type: string,
  idx?: number
) => `${option.id}#${idx}#${type}`;
const getVariationIdAndIndex = (key: string) => key.split('#');

type PromotionsProps = {
  allPromotions?: {
    title: string;
    promotions: SelectablePromotion[];
    type: string;
    handler: (variation: string, index?: number) => void;
  }[];
  selectedOption?: { type?: string; index?: number };
};

export type HopiOption = BasketVariationPromotionViewModel & {
  variation: BasketVariationViewModel;
  entityId: string;
};
export const Promotions = ({
  allPromotions = [],
  selectedOption = {},
}: PromotionsProps) => {
  if (!allPromotions.length) return null;
  const { type: selectedOptionType, index } = !selectedOption
    ? { type: '', index: -1 }
    : selectedOption;

  return (
    <>
      {allPromotions
        ?.filter((p) => p?.promotions?.length)
        .map(({ promotions, title, handler, type }) => {
          return (
            <FlexContainer
              direction='column'
              style={{ marginTop: 16 }}
              key={title}
            >
              <Title>{title}</Title>
              <RadioGroup
                options={promotions}
                getLabel={getLabel}
                getValue={(option, index) => {
                  return getValue(option, type, index);
                }}
                direction='column'
                onChange={handler}
                selectedIndex={selectedOptionType === type ? index : -1}
                getOption={(value) => {
                  const [variationId, index, type] =
                    getVariationIdAndIndex(value);
                  const option = allPromotions
                    ?.find((p) => p?.type == type)
                    ?.promotions?.find((v) => v.id === variationId);
                  return [option, +index] as [HopiOption, number];
                }}
                renderRadioElement={(radio, promotion: HopiOption, index) => (
                  <OptionWrapper key={index as number} {...promotion} gap={16}>
                    {radio}
                  </OptionWrapper>
                )}
                style={{ gap: 8 }}
              />
            </FlexContainer>
          );
        })}
    </>
  );
};

export default Promotions;
